import { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { clearUser } from "../../lib/redux/actions";
import { useNavigate } from "react-router-dom";
import { persistor } from "../../lib/redux/store";
import Cookies from "js-cookie";

export default function LogoutDropDown() {
  const dropdownRef = useRef(null);
  const dispatch = useDispatch();
  const router = useNavigate();
  const [isOpen, setIsOpen] = useState(false);

  const userData = useSelector((state) => state.user);

  const toggleDropdown = () => {
    setIsOpen(!isOpen);
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const handleLogout = () => {
    Cookies.remove("idToken", { path: "/" });
    Cookies.remove("tokenExpiry",{ path: "/" })
       Cookies.remove("lastActiveTime", { path: "/" });
    sessionStorage.clear();
     persistor.purge();
    router("/auth");
    setTimeout(() => {
      dispatch(clearUser());
    }, 1000);
  };

  return (
    <div className="relative" ref={dropdownRef}>
      <button
        onClick={toggleDropdown}
        className="w-8 h-8 rounded-full bg-gray-200 flex items-center justify-center"
        type="button"
      >
        <p className="font-semibold text-[#475467] text-[16px]">
          {" "}
          {userData?.name?.charAt(0)?.toUpperCase() || "D"}
        </p>
      </button>
      {isOpen && (
        <div
          className={`min-w-[240px] max-w-[260px] absolute top-[44px] right-0  shadow-[2px_2px_14px_rgba(0,0,0,0.1)] rounded-[14px] bg-[#f9f9f9] border border-[#e0e0e0] box-border overflow-hidden flex flex-col items-start justify-start p-2 gap-1 text-left text-xs text-[#0d0d0d] font-h m-0`}
        >
          <div className="self-stretch flex flex-col items-start justify-start">
            <div className="self-stretch  flex flex-row items-center justify-start p-2 gap-2">
              <div className="w-[40px] bg-[#EDF2EE] rounded-full border border-[#E0E0E0] box-border h-[40px] overflow-hidden shrink-0 flex flex-col items-center justify-center p-1">
                <p className="font-inter font-semibold text-[16px]">
                  {" "}
                  {userData?.name?.charAt(0)?.toUpperCase() || "D"}
                </p>
              </div>
              <div className="flex-1 flex-col flex justify-between  overflow-hidden">
                <h4 className="text-[#000000] font-medium text-md font-inter text-ellipsis whitespace-nowrap overflow-hidden">
                  {userData?.name}
                </h4>
                <p className="text-[#000000BF] text-md font-inter text-ellipsis whitespace-nowrap overflow-hidden">
                  {userData?.username}
                </p>
              </div>
            </div>
          </div>

          <div className="w-full h-[1px] bg-[#E0E0E0]" />

          <button
            onClick={handleLogout}
            className="self-stretch  gap-2 rounded-lg flex flex-row items-center justify-start pt-3 pb-1.5 px-2.5"
            type="button"
          >
            <div>
              <img className="w-4 relative h-4" alt="" src="/logoutIcon.svg" />
            </div>
            <div className="flex-1 text-start cursor-pointer text-md font-inter font-medium relative overflow-hidden text-ellipsis whitespace-nowrap">
              Log out
            </div>
          </button>
        </div>
      )}
    </div>
  );
}
